import { InfoOutlineIcon } from "@chakra-ui/icons";
import {
  Box,
  Container,
  Divider,
  Heading,
  Icon,
  Spinner,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import { FaGavel, FaShieldAlt, FaUserSecret } from "react-icons/fa"; // Icons for different sections
import { useAbout } from "../../hooks/useAbout.ts"; // Assuming the hook is in the hooks folder

const About = () => {
  const { data, isLoading, error } = useAbout();

  const bgColor = useColorModeValue("gray.50", "gray.800");
  const titleColor = useColorModeValue("blue.600", "blue.300");

  if (isLoading) {
    return (
        <Container maxW="container.xl" py={150} textAlign="center">
          <Spinner size="xl" />
        </Container>
    );
  }

  if (error) {
    return (
        <Container maxW="container.xl" py={150} textAlign="center">
          <Box color="red.500">
            Error loading about data. Please try again later.
          </Box>
        </Container>
    );
  }

  return (
      <Box bg={bgColor} py={10} pt="100px">
        {" "}
        {/* Added pt="100px" for top padding */}
        <Container maxW="container.xl" py={10}>
          {/* Main Heading */}
          <Heading
              as="h1"
              size="2xl"
              color={titleColor}
              textAlign="center"
              mb={8}
          >
            {data?.title || "About"}
          </Heading>


          {/* Section 2: Main Content */}
          <Stack spacing={8} mb={10}>
            {/* Privacy Section */}
            <Box>

              <Text fontSize="md" lineHeight="taller">
                {/* Render the content from API (HTML) */}
                <Box dangerouslySetInnerHTML={{ __html: data?.body }} />
              </Text>
            </Box>

          </Stack>

          {/* Additional Legal Section */}
          <Box textAlign="center" mt={10}>
            <Text fontSize="lg" fontWeight="bold">
              Thank you for being with us!
            </Text>
          </Box>
        </Container>
      </Box>
  );
};

export default About;
